import React, { ReactElement } from 'react';
import { publicSessionApi } from '../../../../../../../../../../redux/views/session-view/session/api/publicApi';
import { Proxy } from '.';

export function ConnectedPublicProxy({
  accessKey,
  sessionUid,
  versionUid,
}: FetchPublicSessionArgs): ReactElement {
  const { sessionProxyAddresses, isLoading, isFetching, isError } =
    publicSessionApi.endpoints.getPublicSession.useQueryState(
      {
        accessKey,
        sessionUid,
        versionUid,
      },
      {
        selectFromResult: ({ data, isLoading, isFetching, isError }) => ({
          isError,
          isFetching,
          isLoading,
          sessionProxyAddresses: data?.sessionDetails.sessionProxyAddresses,
        }),
      },
    );

  return (
    <Proxy
      sessionProxyAddresses={sessionProxyAddresses}
      isLoading={isLoading || isFetching}
      isError={isError}
    />
  );
}
